export default __webpack_public_path__ + "static/media/dailymed.f830ce32.png";